function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.79.75a1 1 0 00-.9.66L2.38 5.69a2.19 2.19 0 000 1.43A2.66 2.66 0 004.84 9a2.74 2.74 0 002.64-2.84A2.74 2.74 0 0010.11 9a2.74 2.74 0 002.64-2.84A2.74 2.74 0 0015.39 9 2.74 2.74 0 0018 6.16 2.74 2.74 0 0020.66 9a2.66 2.66 0 002.48-1.88 2.19 2.19 0 000-1.43l-1.53-4.28a1 1 0 00-.9-.66zM3.75 12V8.74",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.75 8.74V19.5a1.5 1.5 0 01-1.5 1.5h-3M.75 16.5H4.5v6.75H.75",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 13.5a1.75 1.75 0 013.5 0v1.32a.74.74 0 00.57.72l1.73.16a2.26 2.26 0 011.7 2.3l-.15 2.55a3 3 0 01-3 2.7H7.92a2.81 2.81 0 01-.82-.12l-1.82-.51a2.59 2.59 0 00-.78-.12v-4.85a4.94 4.94 0 001.75-4.15z",
  fill: "none"
});

function SvgShopLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default SvgShopLike;